import { render, staticRenderFns } from "./ImageCaptureDialog.vue?vue&type=template&id=1dd88550&scoped=true&"
import script from "./ImageCaptureDialog.vue?vue&type=script&lang=ts&"
export * from "./ImageCaptureDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ImageCaptureDialog.vue?vue&type=style&index=0&id=1dd88550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd88550",
  null
  
)

export default component.exports